import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
    actions: {
        async getContainerMaterialsData(context) {
            const response = await Vue.axios.get(`${URL_API}containermaterial`);
            let data = response["data"];
            context.commit("updateContainerMaterialsData", data);
        },
        async createContainerMaterialData(context, name) {
            const config = {};
            const body = {
                name: name
            };
            await Vue.axios.post(`${URL_API}containermaterial/store`, body, config);
            context.dispatch("getContainerMaterialsData");
        },
        async pushContainerMaterialData(context, { id, name }) {
            const config = {};
            const body = {
                id: id,
                name: name
            };
            await Vue.axios.post(`${URL_API}containermaterial/update`, body, config);
            context.dispatch("getContainerMaterialsData");
        },
        async destroyContainerMaterialData(context, id) {
            const config = {};
            const body = {
                id: id
            };
            await Vue.axios.post(`${URL_API}containermaterial/destroy`, body, config);
            context.dispatch("getContainerMaterialsData");
        }
    },
    mutations: {
        updateContainerMaterialsData(state, containerMaterialsData) {
            state.containerMaterialsData = containerMaterialsData;
        }
    },
    state: {
        containerMaterialsData: []
    },
    getters: {
        allContainerMaterialsData(state) {
            return state.containerMaterialsData;
        }
    }
};